import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */

import ColorCard from './ColorCard';
import { getWidth } from '../utils';
import { css, jsx } from '@emotion/react';
export const MenuList = props => {
  const {
    selectProps: {
      cols
    },
    innerRef,
    children
  } = props;
  return jsx("div", {
    css: colorPaletteContainerStyles,
    role: "radiogroup",
    style: {
      maxWidth: cols ? getWidth(cols) : undefined
    },
    ref: innerRef
  }, children);
};
export const Option = props => {
  const {
    data: {
      value,
      label
    },
    selectProps: {
      checkMarkColor,
      onOptionKeyDown,
      isTabbing
    },
    isFocused,
    isSelected,
    innerProps
  } = props;
  return jsx("div", _extends({
    css: colorCardWrapperStyles
  }, innerProps), jsx(ColorCard, {
    label: label,
    value: value,
    checkMarkColor: checkMarkColor,
    isOption: true,
    focused: isFocused,
    selected: isSelected,
    onKeyDown: value => onOptionKeyDown(value),
    isTabbing: isTabbing
  }));
};
export const DropdownIndicator = () => null;
export const Placeholder = () => null;
const colorCardWrapperStyles = css({
  display: 'flex',
  margin: "var(--ds-space-025, 2px)",
  height: "var(--ds-space-400, 32px)"
});
const colorPaletteContainerStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  padding: "var(--ds-space-050, 4px)"
});